<script>
  import loginServico from './servico';
  import mixinPosLogin from '~js/destino-pos-login';

  export default {
    mixins: [mixinPosLogin],
    components: {  },
    data() {
      return {
        usuario: {},
        tipoDocumento: 'CPF',
        mostrarErroUsuario: false, 
        pessoaFisicaVerificado: false,
        verificacaoDoisFatores: false,
        emailValidacaoWeb: '',
        etapaLogin: 1,
        codigo: '',
        dadosVerificacaoPessoaFisica: {},
        nomeBotao: 'Verificar',
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar: function () {
        if (this.etapaLogin !== 3) {
          this.codigo = '123456';
        }

        this.$validator.validateAll();

        if (this.etapaLogin !== 3) {
          this.codigo = '';
        }

        if (!this.errors.any()) {
          if (this.pessoaFisicaVerificado) {
            this.login();
          } else {
            this.verificar();
          }        
        }
      },
      verificar: function () {
        $('.btn-verificar').button('loading');

        loginServico.verificarPessoaFisica(this.usuario.login)
          .then(resposta => {
            this.pessoaFisicaVerificado = true;
            this.etapaLogin = 2;
            this.dadosVerificacaoPessoaFisica = resposta.body;

            $('.btn-verificar').button('reset');
          })
          .then(() => {
            if (!this.exibirCampoSenha()) {
              this.usuario.senha = 'sem_senha';
            }
          })
          .catch(erro => {
            $('.btn-verificar').button('reset');

            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
            } else if (erro.status === 401) {
              this.$swal('', erro.body.message, 'warning');
            } else {
              this.$swal('', 'Ocorreu um erro ao verificar a pessoa física, caso o erro persista entre em contato com a fundação.', 'error');
            }
            this.$router.push('/login/pessoa-fisica');
          });
      },
      login: function () {
        this.mostrarErroUsuario = false;
        
        $('.btn').button('loading');

        loginServico.pessoaFisica(this.usuario)
          .then(resposta => {
            if (resposta.body.token !== "") {
              this.$storage.usuario(resposta.body.usuario);
              this.$storage.token(resposta.body.token);
            } else {
              $('.btn').button('reset');
              this.emailValidacaoWeb = resposta.body.emailValidacaoWeb;
              this.etapaLogin = 3;
            }
          })
          .then(() => {
            if (this.etapaLogin !== 3) {
              if (!this.exibirCampoSenha()) {
                this.descartarDestinoPosLogin();

                this.$router.push('/web-pessoa-fisica/alterar');
              } else {
                this.irParaDestinoPosLogin('/');
              }           
            }
          })
          .catch(erro => {
            $('.btn').button('reset');
            
            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
            } else if (erro.status === 401) {
              this.$swal('', erro.body.message, 'warning');
            } else {
              this.$swal('', 'Ocorreu um erro no login, caso o erro persista entre em contato com a fundação.', 'error');
            }
            this.$router.push('/login/pessoa-fisica');
          });
      },
      exibirCampoSenha: function () {
        if (this.dadosVerificacaoPessoaFisica) {
          return ((this.dadosVerificacaoPessoaFisica.existePessoa && this.dadosVerificacaoPessoaFisica.pessoaAtiva) || this.dadosVerificacaoPessoaFisica.existePessoaWeb);
        }
        return true;
      },
      limparDocumento() {
        this.usuario.login = '';
      },
      reenviarCodigo() {
        loginServico.reenviarCodigoValidacao(this.usuario).then(resposta => {
          this.$swal('', resposta.body.message, 'success');

        }).catch(erro => {
          this.mostrarErroUsuario = true;
          this.$swal('', erro.body.message, 'error');
        });
      },
      validarDoisFatores() {
        this.usuario.tokenValidacaoWeb = this.codigo;

        loginServico.verificacaoDuasEtapasPessoaFisica(this.usuario).then(resposta => {
          if (resposta.body.token !== "") {
            this.$storage.usuario(resposta.body.usuario);
            this.$storage.token(resposta.body.token);
          }
        })
          .then(() => {
            this.irParaDestinoPosLogin('/');
          })
          .catch(erro => {
            $('.btn').button('reset');
            this.$swal('', erro.body.message, 'error');
            this.$router.push('/login/pessoa-fisica');
          });
      }
    },
    mounted() {
    },
    watch: {
      'tipoDocumento': 'limparDocumento',
    }
  }
</script>

<template>
  <div>
    <form id="verificar-forme" class="m-t" role="form" @submit.prevent="validar" v-show="etapaLogin == 1 && !pessoaFisicaVerificado">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">{{ tipoDocumento }} ou senha incorreto(s).</div>

      <div class="form-froup margin-bottom-10" v-if="false">
        <radio v-model="tipoDocumento"
               selected-value="CPF"
               type="primary"
               text-class="text-white"
               :inline="true">
          Pessoa Física
        </radio>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('documento') }">
        <input type="text"
               class="form-control"
               :placeholder="tipoDocumento"
               name="documento"
               id="documento"
               v-model="usuario.login"
               v-validate="`required|${tipoDocumento.toLocaleLowerCase()}`"
               v-mascara="tipoDocumento.toLocaleLowerCase()">

        <p class="text-danger" v-if="errors.has('documento')">{{ errors.first('documento') }}</p>
      </div>
      <button id="verificar" type="submit"
              class="btn-verificar btn btn-primary block full-width m-b"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Verificando...">
        Verificar
      </button>
    </form>

    <form id="entrar-form" class="m-t" role="form" @submit.prevent="validar" v-show="etapaLogin == 2 && pessoaFisicaVerificado">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">{{ tipoDocumento }} ou senha incorreto(s).</div>

      <div class="text-white form-froup margin-bottom-10" v-if="!exibirCampoSenha()">
        <h3>Pessoa não possui acesso ao portal de pessoas físicas da <b>{{configuracao.abreviaturaFundacao}}</b>.</h3>
        <h3>Clique no botão <b><i>Entrar</i></b> para fazer seu cadastro.</h3>
      </div>

      <div class="text-white form-froup margin-bottom-10" v-if="exibirCampoSenha()">
        <h3>Pessoa encontrada no portal de pessoas físicas da <b>{{configuracao.abreviaturaFundacao}}</b>.</h3>
        <h3>Digite sua senha e clique no botão <b><i>Entrar</i></b>.</h3>
      </div>

      <div class="form-froup margin-bottom-10" v-if="false">
        <radio v-model="tipoDocumento"
               selected-value="CPF"
               type="primary"
               text-class="text-white"
               :inline="true">
          Pessoa Física
        </radio>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('documento') }">
        <input type="text"
               class="form-control"
               :placeholder="tipoDocumento"
               name="documento"
               id="documento"
               v-model="usuario.login"
               v-validate="`required|${tipoDocumento.toLocaleLowerCase()}`"
               v-mascara="tipoDocumento.toLocaleLowerCase()"
               :disabled=true>

        <p class="text-danger" v-if="errors.has('documento')">{{ errors.first('documento') }}</p>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('senha') }" v-if="exibirCampoSenha()">
        <input type="password"
               class="form-control"
               placeholder="*******"
               name="senha"
               v-model="usuario.senha"
               v-validate="'required'">

        <p class="text-danger" v-if="errors.has('senha')">{{ errors.first('senha') }}</p>
      </div>
      <button id="entrar" type="submit"
              class="btn btn-primary block full-width m-b"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Entrando...">
        Entrar
      </button>

      <router-link to="/recuperar-senha-pessoa-fisica" class="text-info">
        <i class="fa fa-lock"></i> RECUPERAR SENHA
      </router-link>
    </form>

    <form id="verificar-forme-dois-fatores" class="m-t" role="form" @submit.prevent="validarDoisFatores" v-show="etapaLogin == 3">

      <div class="text-white form-froup margin-bottom-10">
        <h3>Digite o código de verificação</h3>
      </div>

      <div class="text-white form-froup margin-bottom-10">
        <h5>Um código de verificação foi enviado para o email {{emailValidacaoWeb}}</h5>
      </div>

      <div class="form-group" :class="{ 'has-error': errors.has('codigo') }">
        <input type="text"
               class="form-control"
               name="codigo"
               v-model="codigo"
               maxlength="6"
               id="codigo"
               placeholder="Digite o código de 6 dígitos"
               v-validate="'required'">

        <p class="text-danger" v-if="errors.has('codigo')">{{ errors.first('codigo') }}</p>
      </div>
      <button id="verificarDuasEtapas" type="submit"
              class="btn-verificar btn btn-primary block full-width m-b">
        Verificar
      </button>

      <div class="text-info">
        <div @click="reenviarCodigo" style="cursor: pointer;">
          <i class="fa fa-repeat"></i> Reenviar Código
        </div>
      </div>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/login/LoginPessoaFisica.vue